var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoundingBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 159,
    viewBox: "0 0 160 159",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_489_24300",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 159
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 159,
    height: 159,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_489_24300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 135.812C30.8931 135.812 28.5537 134.839 26.6076 132.893C24.6615 130.947 23.6885 128.607 23.6885 125.875H33.6258V135.812ZM23.6885 112.625V99.3747H33.6258V112.625H23.6885ZM23.6885 86.1247V72.8747H33.6258V86.1247H23.6885ZM23.6885 59.6247V46.3747H33.6258V59.6247H23.6885ZM23.6885 33.1247C23.6885 30.392 24.6615 28.0526 26.6076 26.1065C28.5537 24.1604 30.8931 23.1874 33.6258 23.1874V33.1247H23.6885ZM46.8758 135.812V125.875H60.1258V135.812H46.8758ZM46.8758 33.1247V23.1874H60.1258V33.1247H46.8758ZM73.3758 135.812V125.875H86.6258V135.812H73.3758ZM73.3758 33.1247V23.1874H86.6258V33.1247H73.3758ZM99.8758 135.812V125.875H113.126V135.812H99.8758ZM99.8758 33.1247V23.1874H113.126V33.1247H99.8758ZM126.376 135.812V125.875H136.313C136.313 128.627 135.34 130.971 133.394 132.907C131.448 134.844 129.109 135.812 126.376 135.812ZM126.376 112.625V99.3747H136.313V112.625H126.376ZM126.376 86.1247V72.8747H136.313V86.1247H126.376ZM126.376 59.6247V46.3747H136.313V59.6247H126.376ZM126.376 33.1247V23.1874C129.109 23.1874 131.448 24.1604 133.394 26.1065C135.34 28.0526 136.313 30.392 136.313 33.1247H126.376Z",
    fill: "#E4E4E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoundingBox);
export default __webpack_public_path__ + "static/media/bounding-box.e0be4b122a2888806f2d935c1f1eb23a.svg";
export { ForwardRef as ReactComponent };